import Vue from "vue";
import Vuex from "vuex";
import api from '@/api'
import Message from 'element-ui'

Vue.use(Vuex);
// 定位homePage
export const SET_HOMPAGEID = 'SET_HOMPAGEID'
export const SET_CITYLIST = 'SET_CITYLIST'
export const SET_HOT_CITYLIST = 'SET_HOT_CITYLIST'
export const SET_VISITOR_EXTRA_INFO = 'SET_VISITOR_EXTRA_INFO'
export const SET_BUSINESSCARD_INFO = 'SET_BUSINESSCARD_INFO'
export const SET_CITYID = 'SET_CITYID'
export const SET_PROJECTDETAIL = 'SET_PROJECTDETAIL'

export default new Vuex.Store({
  state: {
    cityId: null,
    homePage: null,
    cityList: null,
    hotCityList: null,
    extraInfo: {},
    businessCard: {},
    projectInfo: {},
  },
  getters: {
    cityId: state => {
      const cityId = sessionStorage.getItem('cityId')
      return state.cityId || JSON.parse(cityId)
    },
    homePage: state => {
      const homePage = sessionStorage.getItem('homePage')
      return state.homePage || JSON.parse(homePage)
    },
    cityList: state => {
      const cityList = sessionStorage.getItem('cityList')
      return state.cityList || JSON.parse(cityList)
    },
    hotCityList: state => {
      const hotCityList = sessionStorage.getItem('hotCityList')
      return state.hotCityList || JSON.parse(hotCityList)
    },
    businessCard: state => {
      return state.businessCard
    },
    // 项目信息
    projectDetail: state => {
      return state.projectInfo || {}
    },
    // 项目图册扁平化
    projectDetailFlatImages: state => {
      const imgArr = []
      if (Array.isArray(state.projectInfo && state.projectInfo.images)) {
        state.projectInfo.images.map(item => item.url).forEach(arr => {
          imgArr.push(...arr)
        })
      }
      return imgArr
    },
     // 资源信息
    projectResources: state => {
      return (state.projectInfo && state.projectInfo.resources || []).map(item => {
        item.name = item.title
        return item
      })
    },
  },
  mutations: {
    [SET_PROJECTDETAIL] (state, data) {
      state.projectInfo = data
      sessionStorage.setItem('projectInfo', JSON.stringify(data))
    },
    [SET_CITYID] (state, data) {
      sessionStorage.setItem('cityId', JSON.stringify(data))
      state.cityId = data
    },
    [SET_HOMPAGEID] (state, data) {
      sessionStorage.setItem('homePage', JSON.stringify(data))
      state.homePage = data
    },
    [SET_CITYLIST] (state, data) {
      sessionStorage.setItem('cityList', JSON.stringify(data))
      state.cityList = data
    },
    [SET_HOT_CITYLIST] (state, data) {
      sessionStorage.setItem('hotCityList', JSON.stringify(data))
      state.hotCityList = data
    },
    [SET_VISITOR_EXTRA_INFO] (state, data) {
      state.extraInfo = data
      sessionStorage.setItem('visitor_extra_info', JSON.stringify(data))
    },
    [SET_BUSINESSCARD_INFO] (state, data) {
      state.businessCard = data
      sessionStorage.setItem('businessCard', JSON.stringify(data))
    },
  },
  actions: {// 设置访客额外信息，基于当前shareId生成
    setVisitorExtraInfo (state, { projectCode, shareId }) {
      return api.getVisitorId(projectCode, shareId).then(res => {
        if (res.code === 200) {
          state.commit(SET_VISITOR_EXTRA_INFO, res.data)
          return res.data
        } else {
          return {}
        }
      })
    },
    setBusinessCard (state, shareId) {
      if (shareId && !['undefined', 'null'].includes(shareId)) {
        return api.getBusinessCard(shareId).then(res => {
          if (res.code !== 200) {
            Message.error({
              message: res.msg
            })
            return
          }
          state.commit(SET_BUSINESSCARD_INFO, res.data)
        })
      }
    },
  },
  modules: {},
})
